<template>
    <InboxMultiDropDown
        placement="top-start"
        :sendBotMessage="sendBotMessage"
        :dataTrees="botsArray"
        @SearchTag="SearchTag"
        :isSearchAble="true"
    >
        <slot />
    </InboxMultiDropDown>
</template>

<script setup>
import InboxMultiDropDown from "@/components/multidropdown/InboxMultiDropdown.vue";

const emits = defineEmits(["SearchTag"]);

const props = defineProps({
    botsArray: {
        type: Array,
        default: [],
    },
    sendBotMessage: {
        type: Function,
        default: () => null,
    },
});

const SearchTag = (e) => {
    emits("SearchTag", e.target.value);
};
</script>

<style scoped></style>
